<template>
  <v-container class="pl-0 ml-0 scrollable-card">
    <v-col class="pl-0 ml-0" cols="9">
      <v-card-text class="pl-0 ml-0">
        <v-form ref="form" v-model="isValid" lazy-validation>
          <v-text-field
            v-model="localForm.firstName"
            label="First Name"
            outlined dense
            @input="emitChange"
          />
          <v-text-field
            v-model="localForm.lastName"
            label="Last Name"
            outlined dense
            @input="emitChange"
          />
          <v-menu
            v-model="datePicker"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="localForm.dateOfBirth"
                label="Date of Birth"
                :append-icon="icons.mdiCalendarRangeOutline"
                readonly outlined dense
                v-bind="attrs" v-on="on"
                :rules="[rules.age]"
                @input="emitChange"
                @click:append="datePicker = true"
              />
            </template>
            <v-date-picker v-model="localForm.dateOfBirth" @input="emitChange" />
          </v-menu>

          <v-select
            v-model="localForm.gender"
            :items="genders"
            label="Gender"
            outlined dense
            @change="onGenderChange"
          />
          
          <v-text-field
            v-model="localForm.email"
            label="Email Address"
            outlined dense
            :rules="[rules.emailOptional]"
            @input="emitChange"
          />
          <v-text-field
            v-model="localForm.phoneNumber"
            label="Phone Number"
            outlined dense
            :rules="[rules.phoneOptional]"
            @input="emitChange"
          />
        </v-form>
      </v-card-text>
    </v-col>
  </v-container>
</template>

<script>
import { mdiMenuDown, mdiCalendarRangeOutline } from '@mdi/js';

export default {
  name: 'BasicOperatorInfoForm',
  props: { form: { type: Object, required: true } },
  data() {
    return {
      isValid: false,
      datePicker: false,
      genders: ['male', 'female', 'other'],
      icons: { mdiMenuDown, mdiCalendarRangeOutline },
      rules: {
        required: v => (!!v || v === false) ? true : 'Required',
        email: v => /^\S+@\S+\.\S+$/.test(v || '') || 'Invalid email',
        emailOptional: v => !v || /^\S+@\S+\.\S+$/.test(v) || 'Invalid email',
        phone: v => !v || /^[+]?[1-9][\d\s\-()/]{7,15}$/.test(v) || 'Invalid phone number format (e.g., +387 63 887 446)',
        phoneOptional: v => !v || /^[+]?[1-9][\d\s\-()/]{7,15}$/.test(v) || 'Invalid phone number format (e.g., +387 63 887 446)',
        age: v => {
          if (!v) return true;
          const today = new Date();
          const birthDate = new Date(v);
          let age = today.getFullYear() - birthDate.getFullYear();
          const monthDiff = today.getMonth() - birthDate.getMonth();
          if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
            age--;
          }
          return age >= 18 || 'Operator must be over 18 years old';
        },
      },
      localForm: {
        firstName: '',
        lastName: '',
        dateOfBirth: null,
        gender: '',
        email: '',
        phoneNumber: '',
      },
    };
  },
  mounted() {
    this.syncFormData();
  },
  watch: {
    form: {
      handler(newVal) {
        if (newVal) {
          this.syncFormData();
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    syncFormData() {
      // Sync parent form data to local form
      if (this.form) {
        Object.keys(this.localForm).forEach(key => {
          if (this.form[key] !== undefined) {
            this.localForm[key] = this.form[key];
          }
        });
      }
    },
    validate() { return this.$refs.form.validate(); },
    onGenderChange(val) {
      this.localForm.gender = (val || '').toLowerCase();
      this.emitChange();
    },
    emitChange() {
      this.$emit('update:form', { ...this.localForm });
    }
  },
};
</script>

  <style>

 .scrollable-card {
    max-height: calc(100vh - 100px); /* Set a maximum height */
    overflow-y: auto;  /* Enable vertical scrolling */
  }

  </style>


